import { inject, observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { updateSearch } from 'bernie-core';

import { ContactHost } from '@shared-ui/retail-lodging-contact-host';
import { useLocalization } from '@shared-ui/localization-context';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';

import { isPetsAmenityFilterPresent } from 'src/common/utils/pets-utils';

import { GroupInput } from './shared-ui-traveler-selector-wrapper';
import { InquiryProminence, PropertyFilterAmenity, RoomInput } from 'src/common/__generated__/api';
import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

interface ContactHostProps extends SharedUiWrapperProps {
  prominence?: InquiryProminence;
  currentHotel?: CurrentHotelStore;
}
const ContactHostWrapper: React.FC<ContactHostProps> = inject(
  'context',
  'currentHotel'
)(
  observer(({ context, currentHotel, inputs, prominence }) => {
    const l10n = useLocalization();
    const history = useHistory();
    const location = useLocation();
    const updateFilter = (payload: any) => {
      const currentSearchCriteria = currentHotel?.searchCriteria;
      if (currentHotel && currentSearchCriteria) {
        const params = {
          ...currentSearchCriteria,
          rooms: payload.rooms,
          amenities: payload.petsIncluded ? PropertyFilterAmenity.PETS : null,
          // eslint-disable-next-line camelcase
          house_rules_group: payload.petsIncluded ? 'pets_allowed' : null,
          localDateFormat: context?.localDateFormat,
        };

        const newParams = InfositeQueryAdapter.parseOut(params, l10n);
        const adults = params.rooms?.reduce((count: number, room: RoomInput) => count + (room.adults || 0), 0) ?? 0;
        const children =
          params.rooms?.flatMap(
            (room: GroupInput, roomIndex: number) => room.children?.map(({ age }) => `${roomIndex + 1}_${age}`) ?? []
          ) ?? [];
        setTimeout(() => updateSearch({ location, history, newParams, replace: true }), 50);

        currentHotel?.setOfferData({ adults, children: children.join(','), petsIncluded: payload.petsIncluded });
        currentHotel.showPetsOnSingleOffer = payload.petsIncluded;
      }
    };
    const contactHostInput = {
      primaryPropertyCriteriaInput: {
        rooms: inputs.searchCriteria.primary.rooms,
        destination: {
          propertyIds: [inputs.propertyId],
        },
        dateRange: inputs.searchCriteria.primary.dateRange,
      },
      petsIncluded: isPetsAmenityFilterPresent(context, currentHotel),
    };

    const contactHostInputWithProminence = {
      prominence,
      inquiryFormInput: contactHostInput,
    };

    return <ContactHost inputs={contactHostInputWithProminence} onFieldsChangeCallback={updateFilter} />;
  })
);

export const SharedUiContactHostWrapper = withSharedUiPropertyOffers(ContactHostWrapper);
SharedUiContactHostWrapper.displayName = 'SharedUiContactHostWrapper';
